import React from "react";
import * as s from "./background.module.css";

import videoMP4 from "../video/background.mp4";
import videoWebM from "../video/background.webm";

export const Background = () => {
	return (
		<video
			className={s.box}
			preload="auto"
			autoPlay
			loop
			playsInline
			muted
			controls={false}
			style={{ width: "100%", objectFit: "cover", height: "100%" }}
		>
			<source src={videoMP4} type="video/mp4" />
			<source src={videoWebM} type="video/webm; codecs=vp9,vorbis" />
		</video>
	);
};
